import { useState } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { TaskDetail } from 'modules/tasks/components/TaskElement/useTaskDetail'

import { useShareTaskProvider } from '../../Provider'
import { Employee } from './Employee'

interface Props {
  task: TaskDetail
}

export const EmployeeList = ({ task }: Props) => {
  const [collapsed, setCollapsed] = useState(false)
  const {
    addedSharedAccesses,
    currentSharedAccesses,
    accessesToRemove,
    newSharedAccessesFiltered,
  } = useShareTaskProvider()

  const assignees = task.assignees.filter((item) => item.id !== task?.author?.id)

  const accessesByIds = (ids: number[]) => {
    return ids
      .map((id: number) => {
        return users.get(id)
      })
      .filter((access) => access && !access.isTerminated)
  }

  return (
    <>
      <Box
        onClick={() => setCollapsed(!collapsed)}
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
      >
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('tasks.share.modal.employees.title')}
        </Text.Normal>
        <Icon.Medium icon={collapsed ? 'chevron-up' : 'chevron-down'} color="grey1000" />
      </Box>

      {!collapsed && (
        <Box gap="s24">
          <Employee
            disabled
            type="author"
            name={String(task?.author?.fullName)}
            avatar={task.author?.avatar}
          />

          {assignees.length > 0 && (
            <Employee
              disabled
              type="assignees"
              badge="user-male-female"
              name={i18n.t('tasks.share.modal.employees.assignees', { number: assignees.length })}
            />
          )}

          {currentSharedAccesses
            .filter((i) => !accessesToRemove.includes(i.id))
            .map((access) => (
              <Employee
                accessId={access.id}
                key={access.id}
                type="shared"
                name={access.fullName}
                avatar={access.avatar}
                jobTitle={access.jobTitle}
              />
            ))}

          {!!addedSharedAccesses.length &&
            accessesByIds(newSharedAccessesFiltered())
              .filter(Boolean)
              .map((access) => {
                return (
                  <Employee
                    accessId={access.id}
                    key={access.id}
                    type="shared"
                    name={`${access.firstName} ${access.lastName}`}
                    avatar={access.avatar}
                    jobTitle={access.employee?.attributes.job_title}
                  />
                )
              })}
        </Box>
      )}
    </>
  )
}
